<template>
    <div v-if="hasLinks" class="social-links">
        <AnimationWrapper
            v-for="(link, index) in filteredLinks"
            :key="link._id || `${link.type}-${index}`"
            :animation-style="animationSettings?.animationStyle !== 'NONE' ? 'FADE_IN' : null"
            :delay-animation="0.6 + index * 0.1"
        >
            <template #animationContent>
                <PortfolioNavigationSocialLinkItem
                    :link="link"
                    :link-type="linkTypeResolved"
                    :link-style="linkStyleResolved"
                    :upper-case="upperCaseResolved"
                />
            </template>
        </AnimationWrapper>
    </div>
</template>

<script>
import PortfolioNavigationSocialLinkItem from "./PortfolioNavigationSocialLinkItem.vue";
import AnimationWrapper from "@/scripts/common/components/AnimationWrapper.vue";
import { mapGetters } from "vuex";
import { SocialLinkStylePascalEnum, SocialLinkTypeEnum } from "@/scripts/common/enums.js";

export default {
    name: "PortfolioNavigationSocialLinks",
    components: { PortfolioNavigationSocialLinkItem, AnimationWrapper },
    props: {
        links: {
            type: Array,
            default: null,
        },
        linkType: {
            type: String,
            default: null,
        },
        linkStyle: {
            type: String,
            default: null,
        },
        upperCase: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        ...mapGetters("view", ["viewData"]),
        ...mapGetters("design", ["animationSettings"]),
        portfolio() {
            return this.viewData?.portfolio;
        },
        linkTypeResolved() {
            if (this.linkType) return this.linkType;
            const value = this.portfolio?.portfolioNavigation?.socialLinks?.type;
            return value?.toLowerCase() === SocialLinkTypeEnum.ICON ? "icon" : "text";
        },
        linkStyleResolved() {
            if (this.linkStyle) return this.linkStyle;
            const value = this.portfolio?.portfolioNavigation?.socialLinks?.style;
            if (value === SocialLinkStylePascalEnum.BOX_SHARP) return "box-sharp";
            if (value === SocialLinkStylePascalEnum.BOX_ROUNDED) return "box-rounded";
            if (value === SocialLinkStylePascalEnum.BOX_PILL) return "box-pill";
            if (value === SocialLinkStylePascalEnum.BOX_PILL_FILL) return "box-pill-fill";
            if (value === SocialLinkStylePascalEnum.UNDERLINE_REGULAR) return "underline-regular";
            return "simple";
        },
        upperCaseResolved() {
            if (this.upperCase) return true;
            return !!this.portfolio?.portfolioNavigation?.menu?.upperCase;
        },
        linksResolved() {
            if (Array.isArray(this.links)) return this.links;
            return this.portfolio?.socialLinks || [];
        },
        filteredLinks() {
            return this.linksResolved.filter((link) => link?.url);
        },
        hasLinks() {
            return this.filteredLinks.length > 0;
        },
    }
};
</script>

<style lang="scss" scoped>
@import "@/styles/layouts/new-portfolio-layout/components/social-links";
</style>
